export const stripeV2Api = 'https://js.stripe.com/v2/';
export const googleClient = 'https://apis.google.com/js/client.js';
export const googleMaps = 'https://maps.googleapis.com/maps/api/js';
